import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { LeadResponse } from './responses/lead.response';

/// A lista do quadro, paginada no servidor; CrmLeadService cuida das ações sobre um lead.
export class CrmLeadListService extends BaseService {
    protected get resourceName(): string {
        return 'crm/leads';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<LeadResponse>>> {
        return await this.get<PagedResponse<LeadResponse>>('paginated' + (filter ?? ''), params);
    }
}
